import { render, staticRenderFns } from "./scroll.vue?vue&type=template&id=0aedbef4&scoped=true&"
import script from "./scroll.vue?vue&type=script&lang=js&"
export * from "./scroll.vue?vue&type=script&lang=js&"
import style0 from "./scroll.vue?vue&type=style&index=0&id=0aedbef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aedbef4",
  null
  
)

export default component.exports